/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolGroupsIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-groups"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M0.93 18.4Q0.38 18.4 -0.01 18.01Q-0.4 17.63 -0.4 17.07L-0.4 16.43Q-0.4 15.15 0.82 14.38Q2.05 13.6 4 13.6Q4.13 13.6 4.21 13.6Q4.3 13.6 4.42 13.6Q4 14.22 3.8 14.93Q3.6 15.63 3.6 16.38L3.6 18.4ZM6.92 18.4Q6.38 18.4 5.99 18.01Q5.6 17.63 5.6 17.07L5.6 16.38Q5.6 15.5 6.05 14.75Q6.5 14 7.38 13.45Q8.25 12.9 9.43 12.63Q10.6 12.35 12 12.35Q13.43 12.35 14.59 12.63Q15.75 12.9 16.63 13.45Q17.5 14 17.95 14.75Q18.4 15.5 18.4 16.38L18.4 17.07Q18.4 17.63 18.01 18.01Q17.63 18.4 17.07 18.4ZM20.4 18.4L20.4 16.38Q20.4 15.6 20.2 14.9Q20 14.2 19.6 13.6Q19.73 13.6 19.81 13.6Q19.9 13.6 20 13.6Q21.98 13.6 23.19 14.38Q24.4 15.15 24.4 16.43L24.4 17.07Q24.4 17.63 24.01 18.01Q23.63 18.4 23.07 18.4ZM4 12.7Q3.08 12.7 2.41 12.04Q1.75 11.38 1.75 10.45Q1.75 9.5 2.41 8.85Q3.08 8.2 4 8.2Q4.95 8.2 5.6 8.85Q6.25 9.5 6.25 10.45Q6.25 11.38 5.6 12.04Q4.95 12.7 4 12.7ZM20 12.7Q19.07 12.7 18.41 12.04Q17.75 11.38 17.75 10.45Q17.75 9.5 18.41 8.85Q19.07 8.2 20 8.2Q20.95 8.2 21.6 8.85Q22.25 9.5 22.25 10.45Q22.25 11.38 21.6 12.04Q20.95 12.7 20 12.7ZM12 11.63Q10.57 11.63 9.59 10.64Q8.6 9.65 8.6 8.22Q8.6 6.8 9.59 5.81Q10.57 4.83 12 4.83Q13.43 4.83 14.41 5.81Q15.4 6.8 15.4 8.22Q15.4 9.65 14.41 10.64Q13.43 11.63 12 11.63Z" fill={color} />
    </svg>
  );
}
